import React from 'react';
import PropTypes from 'prop-types';
import {
  mathDivide,
  mathMultiply,
  To_String,
  showPCNT,
} from '@/utils/common';

/**
 * 允许拖拽组件
 */
export default class DragMaterial extends React.Component {
  static propTypes = {
    children: PropTypes.element.isRequired
  };
  constructor(props){
    super(props);
    this.state = {
      parent: null,
      self: null,
      left: 0,
      top: 0,
      width: 0,
      height: 0,
      startX: 0,
      startY: 0,
    };
  }
  static defaultProps = {
    //默认是移动children dom,覆盖该方法，可以把tranform行为同步给外部
    updatePosition: (tx, ty, tdom) => {
      tdom.style.left = `${tx}px`;
      tdom.style.top = `${ty}px`;
    }
  };
  dragStart = event => {
    event.stopPropagation();
    event.preventDefault();
    let { children, left, top, width, height } = this.props;
    if (event.button !== 0) {
      //只允许左键，右键问题在于不选择conextmenu就不会触发mouseup事件
      return;
    }
    document.addEventListener('mousemove', this.dragMove);
    
    let { 
      pageX,
      pageY,
    } = event;
    
    this.setState({
      left,
      top,
      width,
      height,
      startX: pageX,
      startY: pageY,
    })

    this.tdom2 = this.tdom.cloneNode(true);
    document.body.appendChild(this.tdom2);
    this.tdom2.style.position = "absolute"
    this.tdom2.style.zIndex = "999999"

    children.props.onDrag && children.props.onDrag(children);
  };
  dragMove = event => {
    event.stopPropagation();
    event.preventDefault();
    
    let divcompare = 1;
    let { 
      children, 
      templatewidth: parentWidth,
      templateheight: parentHeight, 
    } = this.props;
    
    let { pageX, pageY } = event;
    let { self, left, top, width, height, startX, startY } = this.state;
    let distanceX = mathDivide(pageX - startX, divcompare);
    let distanceY = mathDivide(pageY - startY, divcompare);
    left = distanceX + left;
    top = distanceY + top;
    if(left < 0) left = 0;
    if(top < 0) top = 0;
    if(left + width > parentWidth){
      left = parentWidth - width;
    }
    if(top + height > parentHeight){
      top = parentHeight - height;
    }
    // let tdom = this.tdom.cloneNode(true);
    // document.body.appendChild(tdom);
    // console.log(tdom)
    // tdom.style.position = "absolute"
    // tdom.style.zIndex = "999999"
    this.props.updatePosition(pageX, pageY, this.tdom2);
    // children.props.onDrag && children.props.onDrag(children);
  };
  dragEnd = event => {
    event.stopPropagation();
    event.preventDefault();
    let {
      offsetLeft,
      offsetTop,
    } = this.tdom;
    this.setState({
      left: offsetLeft,
      top: offsetTop,
    })
    this.tdom2 && this.tdom2.parentNode && this.tdom2.parentNode.removeChild(this.tdom2);
    document.removeEventListener('mousemove', this.dragMove);
  };

  componentDidMount() {
    this.tdom.addEventListener('mousedown', this.dragStart);
    document.addEventListener('mouseup', this.dragEnd);
  }
  componentWillUnmount() {
    this.tdom.removeEventListener('mousedown', this.dragStart);
    document.removeEventListener('mousemove', this.dragMove);
    document.removeEventListener('mouseup', this.dragEnd);
  }
  render() {
    const { children } = this.props;
    const newStyle = {
      ...children.props.style,
      cursor: 'move',
      userSelect: 'none'
    };
    return React.cloneElement(React.Children.only(children), {
      ref: tdom => {
        return (this.tdom = tdom);
      },
      style: newStyle
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/Drag/DragMaterial.js